import {Checkbox, withStyles} from "@material-ui/core";

const CustomCheckbox = withStyles(theme => ({
    root: {
        width: 15,
        color: theme.palette.primary.main,
        "&$checked": {
            color: theme.palette.primary.main
        },
        "&$disabled": {
            color: theme.palette.primary.main
        },
    },
    checked: {},
    disabled: {},

}))(Checkbox);

export default CustomCheckbox;